import { useTranslation } from 'react-i18next'

import { Observation } from '../../types'
import { getAnnotationStatus } from '../../utils/observations'
import Tag from './Tag'
import useStyles from './Tag.styles'

interface AnnotationStatusTagProps {
  observation: Observation
  hideIcon?: boolean
  iconOnly?: boolean
}

const AnnotationStatusTag = ({
  observation,
  hideIcon,
  iconOnly,
}: AnnotationStatusTagProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const annotationStatus = getAnnotationStatus(
    observation.annotationValidation,
    observation.annotationClasses
  )

  return (
    <span className={classes.annotationStatus}>
      {annotationStatus
        ? {
            NOT_ANNOTATED: (
              <Tag
                label={t('Not annotated')}
                appearance="empty"
                hideIcon={hideIcon}
                iconOnly={iconOnly}
              />
            ),
            ANNOTATED: (
              <Tag
                label={t('Annotated')}
                appearance="valid"
                hideIcon={hideIcon}
                iconOnly={iconOnly}
              />
            ),
            EMPTY: (
              <Tag
                label={t('Empty')}
                appearance="valid"
                hideIcon={hideIcon}
                iconOnly={iconOnly}
              />
            ),
            INVALID: (
              <Tag
                label={t('Invalid')}
                appearance="invalid"
                hideIcon={hideIcon}
                iconOnly={iconOnly}
              />
            ),
          }[annotationStatus]
        : undefined}
    </span>
  )
}

export default AnnotationStatusTag
